module.exports = __webpack_public_path__ + "static/public_calendars_3-0ffe60215f7e949956295f5cbc8804db.png";